// A helper function to manage the hook logic and return JSX
import type { FC } from "react";
import { useEffect, useState } from "react";
import { BeamerButton } from "app/components/sidebar3/primary-side-bar/beamer/BeamerButton";
import { EducationElement } from "app/components/sidebar3/primary-side-bar/educationAccount/EducationElement";
import { DefaultFetchService } from "app/services/fetchService";
import Sentry from "@similarweb/sentry-logger";

interface IAccountEducation {
    isPrimarySidebarOpen: boolean;
}

export const AccountEducationComponent: FC<IAccountEducation> = ({ isPrimarySidebarOpen }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        // Fetch data from the server once
        const fetchData = async () => {
            try {
                const collaborationHubLink = "/api/account/collaborationHubLink";
                const fetchService = DefaultFetchService.getInstance();
                const collaborationHubLinkPromise = fetchService.get(collaborationHubLink);
                const response = await collaborationHubLinkPromise;
                setData(response); // Store server result
            } catch (error) {
                Sentry.error("Error fetching AccountEducationComponent data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);
    if (data?.result) {
        return (
            <EducationElement
                link={data?.result}
                isBarOpen={isPrimarySidebarOpen}
            />
        );
    }
    return (
        <BeamerButton
            key="beamerComponentButton"
            isBarOpen={isPrimarySidebarOpen}
        />
    );
};
